import { getOSName } from '@udemy/shared-utils';
import { udLink } from '@udemy/ud-data';
import { addToCartConfig } from './add-to-cart/config';
export const getConfig = (gettext, interpolate, ngettext) => {
  const defaultConfirmationPurchaseSettings = {
    leadText: gettext('Thank you for your order!'),
    moreInfo: gettext('The course will be delivered to your Udemy account as soon as we receive payment confirmation ' + 'from your bank. Once the course is delivered, you will be notified by email.')
  };
  const strings = {
    checkout: gettext('Checkout'),
    hideCodes: gettext('Hide Codes'),
    insertCode: gettext('Insert Code'),
    discountStatusText: {
      applied: gettext('<b>%(couponCode)s</b> is applied'),
      invalid: gettext('%(couponCode)s is not valid'),
      expired: gettext('%(couponCode)s has expired'),
      sold_out: gettext('%(couponCode)s has sold out'),
      unused: gettext('%(couponCode)s is not applied')
    },
    shoppingCart: gettext('Shopping Cart')
  };
  const {
    errors,
    urls
  } = addToCartConfig;
  return {
    checkout: {
      types: ['cart', 'express']
    },
    errors,
    shoppingList: {
      all: ['cart', 'saved_for_later', 'wishlist'],
      listStrings: {
        title: {
          cart: items => interpolate(ngettext('%s Course in Cart', '%s Courses in Cart', items.length), [items.length]),
          saved_for_later: () => gettext('Saved for later'),
          wishlist: () => gettext('Recently wishlisted')
        },
        empty: {
          cartPage: {
            cart: gettext('Your cart is empty. Keep shopping to find a course!'),
            saved_for_later: gettext("You haven't saved any courses for later."),
            wishlist: gettext("You haven't added any courses to your wishlist.")
          },
          dropdown: {
            cart: gettext('Your cart is empty.'),
            wishlist: gettext('Your wishlist is empty.')
          }
        }
      }
    },
    strings,
    performanceMarkName: 'Cart.shopping-item-list-first-img-loaded',
    success: {
      cartSuccess: {
        leadText: gettext("You've successfully added")
      },
      subscribe: {
        headerText: gettext('Jump right in')
      },
      licensePurchase: {
        isConfirmation: false,
        leadText: gettext('Thanks for purchasing %(title)s!'),
        moreInfo: gettext('Invite people to take this course for free with this code! It can be used up to ' + '%(remaining)s times. This redemption code is also included in the payment ' + 'confirmation email for your records.'),
        redemptionCode: gettext('Your redemption code is:')
      },
      multiplePurchase: {
        congratulations: gettext('Congratulations!'),
        headerText: gettext('Your New Purchases'),
        leadText: gettext("You've enrolled in %(count)s courses."),
        myCoursesUrl: '/home/my-courses'
      },
      singlePurchase: {
        headerText: gettext('Jump right in')
      },
      licensePurchaseConfirmation: defaultConfirmationPurchaseSettings,
      singlePurchaseConfirmation: defaultConfirmationPurchaseSettings,
      mobilePurchaseConfirmation: Object.assign({
        ...defaultConfirmationPurchaseSettings
      }, {
        mobileImage: udLink.toImages(`mobile/success/success_${getOSName()}_mobile.jpg`)
      }),
      multiplePurchaseConfirmation: Object.assign({
        ...defaultConfirmationPurchaseSettings
      }, {
        moreInfo: gettext('We are excited for you to start learning. The courses will be delivered ' + 'to your Udemy account as soon as we receive payment confirmation from ' + 'your bank. Once the courses are delivered, you will be notified by email ' + 'so you can get back to learning!')
      })
    },
    urls
  };
};
//# sourceMappingURL=config.js.map